import script from "./AppServices.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppServices.vue?vue&type=script&setup=true&lang=ts"

import "./AppServices.vue?vue&type=style&index=0&id=274eb486&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274eb486"]])

export default __exports__